import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserControls from 'flarum/forum/utils/UserControls';
import UserPage from 'flarum/forum/components/UserPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import CreditPage from './components/CreditPage';
import NotificationCenterPage from './components/NotificationCenterPage';
import CupExchangeModal from './components/CupExchangeModal';

app.initializers.add('taro-core', () => {
  // ── 圣杯兑换全局入口（taro-shell 导航等外部可唤起）──
  app.taroCupExchange = {
    open() {
      app.modal.show(CupExchangeModal);
    },
  };

  // ── 用户子页面路由（渲染在个人主页右侧内容区）──
  app.routes['user.taroCredits'] = { path: '/u/:username/credits', component: CreditPage };
  app.routes['user.taroNotifications'] = { path: '/u/:username/notifications', component: NotificationCenterPage };
  // 保留旧版独立路由作为别名（兼容已有链接）
  app.routes['taro.credits.page'] = { path: '/taro/credits', component: CreditPage };

  // ── 个人主页侧边栏导航 ──

  extend(UserPage.prototype, 'navItems', function(items) {
    const user = this.user;
    if (!user) return;

    const isActor = app.session.user === user;
    if (!isActor) return;

    items.add('taroCredits', LinkButton.component({
      href: app.route('user.taroCredits', { username: user.slug() }),
      icon: 'fas fa-coins'
    }, '我的积分'), 80);

    items.add('taroNotifications', LinkButton.component({
      href: app.route('user.taroNotifications', { username: user.slug() }),
      icon: 'fas fa-bell'
    }, '通知中心'), 75);
  });

  // ── 个人主页卡片控制按钮（UserControls）──

  extend(UserControls, 'controls', function(ctrlItems, user) {
    if (app.session.user && app.session.user.id() === user.id()) {
      ctrlItems.add('taroCredits', LinkButton.component({
        href: app.route('user.taroCredits', { username: user.slug() }),
        icon: 'fas fa-coins'
      }, '我的积分'));
    }
  });

  // ── 首页 Banner 覆写 ──
  // 原 WelcomeHero 含可关闭按钮，用户点 × 后永远不显示。改用 override 完全替换
  // hero() 为永久 banner，与 tags / 插件页 banner 视觉一致。

  override(IndexPage.prototype, 'hero', function () {
    const title = app.forum.attribute('welcomeTitle') || app.forum.attribute('title') || '格林塔罗';
    const subtitle = app.forum.attribute('welcomeMessage') || '';

    return (
      <header className="Hero TaroHomeHero">
        <div className="container">
          <h1 className="Hero-title">
            <i className="fas fa-moon" style={{ marginRight: '8px' }} />
            {title}
          </h1>
          {subtitle ? <div className="Hero-subtitle">{subtitle}</div> : null}
        </div>
      </header>
    );
  });
});
